
export class EventRequesAcknowledgeListModel {
  id: number;
  requestId: number;
  requestNumber: string;
  permissionName: string;
  postedDate: Date;
  actionDate: Date;
  remarks: string;
  requestAcknowledgeStatus: string;

}



// WEBPACK FOOTER //
// ./src/app/core/models/event-request-acknowledge-list.ts